<template>
  <div class="page-box">
    <div class="c_page-title">
      <div>赔付明细单详情</div>
    </div>
    <div style="margin-bottom: 15px">
      <div class="header-text">
        <div>
          赔付单号:{{ detailInfo.head_data.pf_no }}&nbsp;&nbsp;&nbsp;
          生成时间:{{ detailInfo.head_data.created_at }}&nbsp;&nbsp;&nbsp;
          赔付单状态：
          <span
            :style="{
              color:
                detailInfo.head_data.status === STATUS_AGAIN_SUBMIT
                  ? '#f56c6c'
                  : '#000',
            }"
          >
            {{ detailInfo.head_data.status_msg }}
          </span>
          <!-- <span v-else style="color: #67c23a">{{
            getBillStatus(bill_info.status)
          }}</span> -->
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <el-row>
      <el-col class="card-block">
        <div class="table-box">
          <div>
            赔付单商品信息： 共 {{ detailInfo.head_data.total_goods_num }} 件
            {{ detailInfo.head_data.total_pf_price }}元
          </div>
          <div v-if="isShowPayeeModuleButtonMarking" style="margin-left: auto">
            <el-button type="primary" size="mini" @click="handleMarking">
              打标
            </el-button>
            <el-button type="success" size="mini" @click="handleMarkingSubmit">
              提交打标数据并入库
            </el-button>
          </div>
        </div>

        <div v-if="detailInfo.detail_list.length > 0" style="margin-bottom: 0">
          <el-table
            :data="detailInfo.detail_list"
            tooltip-effect="dark"
            style="width: 100%"
            border
          >
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="psp_id"
              label="前置仓计划编号"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>

            <el-table-column
              prop="goods_name"
              label="商品名称"
              width="80"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_kh"
              label="款号"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              width="80"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              width="80"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="si_val"
              label="尺码"
              width="80"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="sku"
              label="sku编号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cat_name"
              label="商品分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stock_source"
              label="入库来源"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="is_on_sale_msg"
              label="商品状态"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exception_source"
              label="异常来源"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exception_admin"
              label="标记异常人"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="exception_time"
              label="标记异常时间"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="original_market_price"
              label="原商家价"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="actual_market_price"
              label="实际赔付价"
              width="120"
              align="center"
            >
              <template slot-scope="{ row, $index }">
                <el-button
                  v-if="!row._showInputPrice"
                  :disabled="
                    ![STATUS_WAIT_SUBMIT, STATUS_AGAIN_SUBMIT].includes(
                      detailInfo.head_data.status
                    )
                  "
                  @click="handlePriceButtonClick(row, $index)"
                >
                  {{ row.actual_market_price }}</el-button
                >
                <el-input
                  v-else
                  v-model="row.actual_market_price"
                  clearable
                  @change="handlePriceInputEnter(row, $index)"
                  @focus="handlePriceInputFocus(row, $index)"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="diff_price"
              label="差额"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span style="color: red">
                  {{ scope.row.diff_price }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="stock_in_price"
              label="入库金额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="new_dbid"
              label="新打标ID"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="new_stock_source"
              label="新入库来源"
              width="90"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col v-if="isShowPayeeModule" class="card-block">
        <div class="table-box">
          <div v-if="isShowPayeeModuleTitle">
            收款人信息
            <span
              v-if="detailInfo.head_data.pay_tool === PAY_TOOL_SUB"
              style="color: red"
              >(分账不需要选择收款信息)</span
            >
            <span
              v-if="detailInfo.head_data.pay_tool === PAY_TOOL_TRANSFER"
              style="color: red"
              >(转账支付需要选择收款信息)</span
            >
          </div>
          <div v-if="isShowPayeeModuleButton2" style="margin-left: auto">
            <el-button
              type="success"
              size="mini"
              @click="handleCompensateSubmit"
            >
              提交赔付单
            </el-button>
            <el-button type="info" size="mini" @click="handleCancellation">
              作废
            </el-button>
          </div>
          <div v-if="!isShowPayeeModuleButton" style="margin-left: auto">
            <el-button type="success" size="mini" @click="handleCompensatePass">
              通过
            </el-button>
            <el-button type="info" size="mini" @click="handleCompensateReject">
              驳回
            </el-button>
          </div>
        </div>
        <div v-if="detailInfo.payees.length > 0" style="margin-bottom: 0">
          <el-table
            v-if="isShowPayeeModuleTable"
            ref="multipleTable"
            :data="payeesList"
            tooltip-effect="dark"
            style="width: 100%"
            border
          >
            <el-table-column
              v-if="isShowPayeeModuleRadio"
              label="选择"
              align="center"
              width="80"
            >
              <template slot-scope="{ row }">
                <el-radio v-model="compensateform.payee_id" :label="row.id">{{
                  ""
                }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              prop="pay_contact"
              label="收款人名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_bank"
              label="收款银行"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cnap_name"
              label="收款银行支行"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_account"
              label="收款账号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
          <el-input
            v-if="isShowPayeeModuleInput"
            v-model="compensateform.log_remark"
            type="textarea"
            placeholder="操作备注（200字以内）"
            maxlength="200"
            :rows="2"
            show-word-limit
          />
        </div>
      </el-col>
      <el-col class="card-block">
        <div class="table-box">
          <div>操作日志</div>
        </div>
        <div v-if="detailInfo.operate_log.length > 0" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            :data="detailInfo.operate_log"
            tooltip-effect="dark"
            style="width: 100%"
            border
          >
            <el-table-column
              label="操作人"
              prop="action_admin"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="action_type"
              label="操作方式"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="action_desc"
              label="操作备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!--  -->
    <el-dialog
      :visible.sync="recall_dbid.showDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <div slot="title">
        <p>
          请扫描打标ID:<span style="color: red">{{
            ` 已打标${recall_dbid.dbids.length}个`
          }}</span>
        </p>
      </div>
      <div label-position="right" label-width="60px">
        <div label="标号：">
          <el-input
            ref="recallInput"
            v-model="recall_dbid.inputValue"
            placeholder="输入标号"
            style="width: 100%"
            @submit.native.prevent
            @keyup.native.enter="enterRecallDbid"
          ></el-input>
        </div>
        <div>
          <el-tag
            v-for="(item, index) in recall_dbid.dbids"
            :key="item"
            style="margin: 5px 10px 5px 0"
          >
            {{ item }}
            <i class="el-icon-close" @click="handleRemoveDbid(index, item)" />
          </el-tag>
        </div>
      </div>
      <div style="text-align: right; margin-top: 20px">
        <el-button type="info" @click="handleRecallDbid">全部撤标</el-button>
        <el-button type="primary" @click="recall_dbid.showDialog = false">
          结束
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDetailList,
  updateActualMarketPrice,
  purchaseAdoptCompensate,
  cancelCompensate,
  rejectCompensate,
  storehouseAdoptCompensate,
  submitDbid,
  pFDaBiao,
  removeDbid,
} from "@/controller/goodsCompensate.js";

const STATUS_WAIT_SUBMIT = "1"; // 待提交
const STATUS_AGAIN_SUBMIT = "4"; // 重新提交
const STATUS_CANCEL = "2"; // 已作废
const STATUS_WAIT_AUDIT = "3"; // 仓储待审核
const STATUS_WAIT_IN_STORAGE = "5"; // 待入库
const STATUS_WAIT_PAY = "6"; // 待支付
const STATUS_WAIT_DONE = "7"; // 已完成
const PAY_TOOL_SUB = "2"; // 分账
const PAY_TOOL_TRANSFER = "0"; // 转账
export default {
  name: "CompensateListDetail",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const _vm = vm;
      _vm.form.pf_id = to.query.pf_id;
      _vm.fetchData();
      //   vm.getActivityGoodsInfo();
    });
  },
  data() {
    return {
      STATUS_WAIT_SUBMIT,
      STATUS_AGAIN_SUBMIT,
      STATUS_CANCEL,
      STATUS_WAIT_AUDIT,
      STATUS_WAIT_IN_STORAGE,
      STATUS_WAIT_PAY,
      STATUS_WAIT_DONE,
      PAY_TOOL_SUB,
      PAY_TOOL_TRANSFER,
      form: {
        pf_id: "",
      },
      detailInfo: {
        head_data: {}, // 顶部数据
        detail_list: [], // 详情数组
        payees: [], // 收款人数组
        operate_log: [], // 操作日志数组
      },
      currentOriginActualMarketPrice: "", // 当前编辑的原价格
      compensateform: {
        payee_id: "",
        log_remark: "",
      }, // 提交赔付单参数
      recall_dbid: {
        inputValue: "",
        dbids: [], // 已打标的dbid
        showDialog: false,
      },
      websocket: null, // 打印机用的长连接
      printData: "", // 打印内容
    };
  },
  //   created() {
  //     this.fetchData();
  //   },
  computed: {
    // 收款信息
    payeesList() {
      if (this.detailInfo.head_data.pay_tool === PAY_TOOL_TRANSFER) {
        return this.detailInfo.payees;
      }
      return this.detailInfo.payees.filter((item) => {
        if (item.is_default === "1") {
          return item;
        }
      });
    },
    // 除了待入库跟已作废都展示
    isShowPayeeModule() {
      return ![STATUS_CANCEL, STATUS_WAIT_IN_STORAGE].includes(
        this.detailInfo.head_data.status
      );
    },
    // 待审核不展示标题
    isShowPayeeModuleTitle() {
      return ![STATUS_WAIT_AUDIT].includes(this.detailInfo.head_data.status);
    },
    // 待审核展示按钮
    isShowPayeeModuleButton() {
      return ![STATUS_WAIT_AUDIT].includes(this.detailInfo.head_data.status);
    },
    // 是否展示赔付单，作废按钮
    isShowPayeeModuleButton2() {
      return [STATUS_AGAIN_SUBMIT, STATUS_WAIT_SUBMIT].includes(
        this.detailInfo.head_data.status
      );
    },
    // 待审核展示表格 并且isShowPayeeModule
    isShowPayeeModuleTable() {
      return (
        ![STATUS_WAIT_AUDIT].includes(this.detailInfo.head_data.status) &&
        this.isShowPayeeModule
      );
    },
    // 待提交 重新提交
    isShowPayeeModuleRadio() {
      return (
        [STATUS_WAIT_SUBMIT, STATUS_AGAIN_SUBMIT].includes(
          this.detailInfo.head_data.status
        ) && this.detailInfo.head_data.pay_tool === PAY_TOOL_TRANSFER
      );
    },
    // 待提交 重新提交 带审核
    isShowPayeeModuleInput() {
      return [
        STATUS_WAIT_SUBMIT,
        STATUS_AGAIN_SUBMIT,
        STATUS_WAIT_AUDIT,
      ].includes(this.detailInfo.head_data.status);
    },
    // 待入库-打标按钮
    isShowPayeeModuleButtonMarking() {
      return [STATUS_WAIT_IN_STORAGE].includes(
        this.detailInfo.head_data.status
      );
    },
  },
  created() {
    this.initWebSocket();
    this.getDaBiaoData();
  },

  // 页面销毁时关闭长连接
  destroyed() {
    if (this.isShowPayeeModuleButtonMarking) {
      this.websocket?.close();
    }
  },
  methods: {
    initWebSocket() {
      // 初始化weosocket
      const ishttps = document.location.protocol === "https:";
      let wsuri = "ws://localhost:13528";
      if (ishttps) {
        wsuri = "wss://localhost:13529"; // https wss地址
      }
      this.websocket = new WebSocket(wsuri);
      this.websocket.onerror = () => {
        // this.$alert("请确保打印机连接无误！", "提示");
      };
      console.log("初始化成功", this.websocket);
      this.websocket.onmessage = (e) => {
        const obj = JSON.parse(e.data);
        if (obj.cmd === "print") {
          if (obj.status === "failed") {
            this.$confirm(obj.msg, "提示", {
              confirmButtonText: "重新打印",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.doPrint(); // 第一次调用打印机的时候已经设置过printData了 再次调用的时候不用再传数据了
            });
          }
        }
      };
    },
    // 打标之后注册进去
    addStopLeave() {
      window.addEventListener("beforeunload", this._stopLeave);
    },

    // 移除关闭窗口的提示
    removeStopLeave() {
      window.removeEventListener("beforeunload", this._stopLeave);
    },
    // 执行打印
    doPrint(printData) {
      this.printData = JSON.stringify(printData);
      this.websocket.send(this.printData);
    },
    fetchData() {
      getDetailList(this.form)
        .then((data) => {
          this.detailInfo = data;
          this.detailInfo.detail_list.map((item) => {
            const newItem = item;
            newItem._showInputPrice = false;
            return newItem;
          });
          // 刷新页面的时候先重置数据
          this.compensateform = this.$options.data.call(this).compensateform;
          // 设置默认选中收款人
          this.detailInfo.payees.forEach((item) => {
            if (item.is_default === "1") {
              this.compensateform.payee_id = item.id;
            }
          });
        })
        .catch(this.$noop);
    },
    // 聚焦先保存原来价格
    handlePriceInputFocus(row) {
      this.currentOriginActualMarketPrice = row.actual_market_price;
    },
    // 编辑价格
    handlePriceInputEnter(row, index) {
      this.$confirm("确定修改价格吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateActualMarketPrice({
            pfd_id: row.id,
            actual_market_price: row.actual_market_price,
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "实际赔付价更新成功",
              });
              //   const newRow = { ...row, _showInputPrice: false };
              //   this.$set(this.detailInfo.detail_list, index, newRow);
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(() => {
          // 还原
          const newRow = {
            ...row,
            actual_market_price: this.currentOriginActualMarketPrice,
            _showInputPrice: false,
          };
          this.$set(this.detailInfo.detail_list, index, newRow);
        });
    },
    // 点击价格按钮
    handlePriceButtonClick(row, index) {
      const newRow = { ...row, _showInputPrice: true };
      this.$set(this.detailInfo.detail_list, index, newRow);
    },
    // 提交赔付单
    handleCompensateSubmit() {
      //   if (this.compensateform.payee_id === "") {
      //     this.$message({
      //       type: "error",
      //       message: "请选择收款人",
      //     });
      //     return;
      //   }
      const params = {
        pf_id: this.form.pf_id,
        payee_id: this.compensateform.payee_id,
        log_remark: this.compensateform.log_remark,
      };
      purchaseAdoptCompensate(params)
        .then(() => {
          this.$message({
            type: "success",
            message: "已提交赔付单，流转成功",
          });
          this.fetchData();
        })
        .catch(this.$noop);
    },
    // 作废
    handleCancellation() {
      this.$confirm(
        "作废后商品将恢复至异常库存明细，确定作废赔付单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          cancelCompensate({
            pf_id: this.form.pf_id,
            log_remark: this.compensateform.log_remark,
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "赔付单作废成功",
              });
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(() => {
          console.log("关闭");
        });
    },
    // 通过
    handleCompensatePass() {
      storehouseAdoptCompensate({
        pf_id: this.form.pf_id,
        log_remark: this.compensateform.log_remark,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.fetchData();
        })
        .catch(this.$noop);
    },
    // 驳回
    handleCompensateReject() {
      this.$confirm(
        "驳回后赔付单状态将变为“待重新提交”，确定驳回赔付单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          rejectCompensate({
            pf_id: this.form.pf_id,
            log_remark: this.compensateform.log_remark,
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "驳回成功",
              });
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(() => {
          console.log("关闭");
        });
    },
    // 显示打标窗口
    handleMarking() {
      console.log("显示打标窗口");
      // 判断有无连接打印机
      if (!this.websocket) {
        this.$alert("请确保打印机连接无误！", "提示");
        return;
      }
      this.getDaBiaoData();
      this.recall_dbid.showDialog = true;
      this.$nextTick(() => {
        this.$refs.recallInput.focus();
      });
    },
    getDaBiaoData() {
      const parmas = {
        dbid: "", // 旧的dbid，可为空，为空则显示数量和已打标数据
        pf_id: this.form.pf_id,
      };
      // 获取没有提交的dbid
      pFDaBiao(parmas)
        .then((data) => {
          this.recall_dbid.dbids = data.newDbid;
        })
        .catch(this.$noop);
    },
    // 扫描输入pfid
    enterRecallDbid() {
      // 匹配打标id后面的数字
      const match = /^dbid=(\d+)$/.exec(this.recall_dbid.inputValue); // match[1]就是匹配出来的数字了
      console.log(match);
      let dbid = "";
      if (match === null || match.length < 2) {
        dbid = this.recall_dbid.inputValue;
      } else {
        dbid = match[1];
      }
      const parmas = {
        pf_id: this.form.pf_id,
        dbid,
      };
      // 获取没有提交的dbid
      pFDaBiao(parmas)
        .then((data) => {
          this.recall_dbid.dbids = data.newDbid;
          this.recall_dbid.showDialog = true;
          const { printData } = data;
          this.websocket.send(JSON.stringify(printData));
          this.fetchData();
          this.$nextTick(() => {
            this.$refs.recallInput.focus();
            // this.killScanDbids(match[1]);

            this.recall_dbid.inputValue = "";
          });
        })
        .catch(this.$noop);
    },

    // 处理已扫描的dbid, dbid重复则splice, 没有则push
    killScanDbids(dbid) {
      const idx = this.recall_dbid.dbids.indexOf(dbid);
      console.log(idx);

      if (idx > -1) {
        // 有就切掉
        this.recall_dbid.scanDbids.splice(idx, 1);
        return;
      }
      // 没有就加上
      this.recall_dbid.scanDbids.push(dbid);
    },
    // 单个撤标
    handleRemoveDbid(index, dbid) {
      this.$confirm("撤标后需要重新打标，确认撤标吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeDbid({ new_dbid: dbid, pf_id: this.form.pf_id })
            .then(() => {
              this.$message({
                type: "success",
                message: "撤标成功",
              });
              this.recall_dbid.dbids.splice(index, 1);
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(() => {
          console.log("关闭");
        });
    },
    // 全部撤标
    handleRecallDbid() {
      this.$confirm("撤标后需要重新打标，确认撤标吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeDbid({
            new_dbid: this.recall_dbid.dbids,
            pf_id: this.form.pf_id,
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "撤标成功",
              });
              this.recall_dbid.dbids = [];
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(() => {
          console.log("关闭");
        });
    },
    // 打标数据入库
    handleMarkingSubmit() {
      const h = this.$createElement;
      let scanDbidsNum = 0;
      let alreadyDone = 0;
      this.detailInfo.detail_list.forEach((item) => {
        if (item.new_dbid === "") {
          scanDbidsNum += 1;
        } else {
          alreadyDone += 1;
        }
      });
      this.$msgbox({
        title: "提示",
        message: h(
          "p",
          null,
          `已打标${alreadyDone}件，还有${scanDbidsNum}件未打标，提交后商品即为“已入库”并生成账单，未打标商品将会恢复至库存异常明细表，确认提交数据并入库？`
        ),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          submitDbid({
            pf_id: this.form.pf_id,
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(() => {
          console.log("关闭");
        });
    },
  },
};
</script>
<style scoped>
.header-text {
  background: #f3f3f3;
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
}

.page-item {
  margin-top: 20px;
}

.page-box {
  padding: 0 20px;
}

.bill-goods-header {
  display: flex;
  flex-direction: row;
  height: 40px;
  line-height: 40px;
  background-color: rgb(243, 243, 243);
}

.el-tag--warning {
  background-color: rgb(255, 218, 114);
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.card-warning {
  background: #e8aae1;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.table-box {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
}

.card-block {
  border: 1px solid #ddd;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/CompensateListDetail.vue